<span [className]="getAvatarClassName(size)" *ngIf="size !== 'xl'">
  <img
    *ngIf="this.entityWithAvatar?.avatar"
    alt="{{ this.entityWithAvatar?.name }}"
    [title]="this.entityWithAvatar?.name"
    src="{{this.entityWithAvatar?.avatar}}"
    class="rounded-circle avatar-sm"
  />
  <div *ngIf="!this.entityWithAvatar?.avatar">
    {{this.entityWithAvatar?.name?.substring(0, 1)?.toUpperCase()}}
  </div>
</span>

<div class="card-profile-image icon-wrapper" *ngIf="size === 'xl'" [attr.data-tour-id]="tourIdPrefix || null">
  <a href="javascript:void(0)" [attr.data-tour-id]="tourIdPrefix ? tourIdPrefix + '-upload' : null" (click)="avatarInputFile.click()">
    <img
      *ngIf="this.entityWithAvatar?.avatar"
      alt="Image placeholder"
      src="{{this.entityWithAvatar?.avatar}}"
      class="rounded-circle avatar-xl"
      [matTooltip]="'core.avatar.upload' | translate"
    />
    <img
      *ngIf="!this.entityWithAvatar?.avatar"
      src="assets/img/theme/upload-photo-bg.png"
      class="rounded-circle avatar-xl"
      [matTooltip]="'core.avatar.upload' | translate"
    />
  </a>

  <div *ngIf="this.entityWithAvatar?.avatar"
       [attr.data-tour-id]="tourIdPrefix ? tourIdPrefix + '-remove' : null"
       (click)="deleteAvatar()"
       [matTooltip]="'core.avatar.remove' | translate"
       class="badge badge-circle badge-outline badge-primary bg-white avatar-remove-btn">
    <i class="fa-solid fa-xmark"></i>
  </div>

  <input type="file" #avatarInputFile [attr.data-tour-id]="tourIdPrefix ? tourIdPrefix + '-input' : null" accept="image/jpeg,image/png,image/webp" (change)="uploadAvatar($event)" />
</div>

<div class="avatar-cropper-overlay" *ngIf="openCropper" (mousemove)="onDrag($event)" (mouseup)="onEndDrag()" (mouseleave)="onEndDrag()">
  <div class="avatar-cropper-modal">
    <h5 class="mb-2">Ajuste o avatar (1:1)</h5>
    <div class="text-muted mb-2 small">Arraste a imagem para posicionar e use o zoom.</div>

    <canvas
      #cropPreviewCanvas
      class="avatar-cropper-preview"
      width="320"
      height="320"
      (mousedown)="onStartDrag($event)">
    </canvas>

    <div class="mt-3">
      <label class="small text-muted mb-1">Zoom</label>
      <input type="range" min="1" max="3" step="0.01" [value]="zoom" (input)="onZoomChange($event)" class="w-100" />
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="cancelCrop()">Cancelar</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="applyCrop()">Aplicar</button>
    </div>
  </div>
</div>
